module.exports = __webpack_public_path__ + "media/AUDIO-01.ca5045c4.mp3";